// import AppConfig from '@/app.config.js'
import { adminMenuItems } from "@/configs/menu.config.js"

class LayoutService {

    menuItems() {
        return adminMenuItems
    }

}

export default new LayoutService();
